<div class="px-3 py-2">
	<h4 align="center">Cifris Chain 2018</h4>
	<p>Il <b>17 dicembre 2018</b> si è svolto a Roma l'evento Cifris Chain 2018, 
		primo incontro tra i partecipanti all'iniziativa Cifris Chain della costituenda 
		Associazione De Cifris.</p>
	<b>Luogo: Università Roma Tre - Aula Urbano VIII in Via Madonna dei Monti 40, Roma.</b>
	<p>Questo evento ha offerto una panoramica sulle attività accademiche ed industriali 
		riguardanti gli aspetti crittografici della tecnologia Blockchain e le cryptocurrency.
		È stata inoltre l'occasione per presentare l'iniziativa Cifris Chain</p>
	<h6>Programma dell'evento</h6>
	<ul>
		<li>
			<p><b>10:10 - 11:20  Sessione I</b></p>
			<ul class="ulSon">
				<li>
					<p>10:10 Prof.ssa Silvia Ciucciovino<br>
						Università Roma Tre
						<i style="color: green;">Prorettore con delega ai rapporti con il mondo del lavoro</i><br>
					</p>
				</li>
				<li>
					<p>10:30 Prof. Massimiliano Sala<br>
						De Componendis Cifris <br>
						<i style="color: green;">Acting Director</i> <br>
						<a href="../../../../assets/eventi/2018/CifrisChain/Slide_MSala.pdf">Slide</a>
					</p>
				</li>
				<li>
					<p>10:50 Prof. Ivan Visconti<br>
						Università di Salerno <br>
						<i style="color: green;">Coordinatore di Cifris Chain</i> <br>
						<a href="../../../../assets/eventi/2018/CifrisChain/Slide_IVisconti.pdf">Slide</a>
					</p>
				</li>
			</ul>
		</li>
		<li><p><b>11:15 - 11:45  Pausa caffè</b></p></li>
		<li>
			<p><b>11:45 - 13:00  Sessione II</b></p>
			<ul class="ulSon">
				<li>
					<p>11:45 Dott. Marco Benedetti<br>
						Banca d'Italia, Dipartimento ICT <br>
						Capo della Divisione Ricerca Tecnologie Avanzate <br>
						<a href="../../../../assets/eventi/2018/CifrisChain/Slide_Benedetti.pdf">Lightning 
							Network: Cryptography to the rescue of Cryptography?</a>
					</p>
				</li>
				<li>
					<p>12.10 Prof. Daniele Venturi <br>
						Università di Roma "La Sapienza" <br>
						<a href="../../../../assets/eventi/2018/CifrisChain/Slide_DVenturi.pdf">Panoramica 
							su alcune attività didattiche e di ricerca in Cifris Chain</a>
					</p>
				</li>
				<li>
					<p>12:35 Prof. Andrea Visconti<br> 
						Università di Milano<br>
						<a href="../../../../assets/eventi/2018/CifrisChain/Slide_AVisconti.pdf">Panoramica 
							su alcuni progetti industriali in Cifris Chain</a>
					</p>
				</li>
			</ul>
		</li>
		<li><p><b>13:00 - 14:15  Pausa pranzo</b></p></li>
		<li><p><b>14:15 - 15:45  Sessione III</b></p>
			<ul class="ulSon">
				<li>
					<p>14:15 Dott. Andrea Di Nenno <br>
						Telsy e Politecnico di Torino <br>
						<a href="../../../../assets/eventi/2018/CifrisChain/Slide_ADiNenno.pdf">Decentralised 
							and Secure Analytics System</a>
					</p>
				</li>
				<li>
					<p>14.30 Dott. Alessio Meneghetti<br>
						Università di Trento <br>
						<a href="../../../../assets/eventi/2018/CifrisChain/Slide_AMeneghetti.pdf">Blockchain 
							per processi aziendali in una grande azienda</a>
					</p>
				</li>
				<li>
					<p>14:45 Dott. Paolo Campegiani<br>
						Bit4id<br>
						<a href="../../../../assets/eventi/2018/CifrisChain/Slide_PCampegiani.pdf">Le attività 
							di standardizzazione su blockchain e distributed ledger in Italia, 
							in Europa e nel mondo</a>
					</p>
				</li>
				<li>
					<p>15:10 Prof. Massimo Bartoletti<br>
						Università di Cagliari <br>
						<a href="../../../../assets/eventi/2018/CifrisChain/Slide_MBartoletti.pdf">Modelling 
							and verifying Bitcoin contracts</a>
					</p>
				</li>
			</ul>
		</li>
		<li><p><b>15:40 - 16:10  Pausa caffè</b></p></li>
		<li><p><b>16:10 - 17:00  Sessione IV</b></p>
			<ul class="ulSon">
				<li>
					<p>16:10 Panel: Criticità in Blockchain e Cryptocurrency
					</p>
				</li>
				<li>
					16:40 Conclusioni e Networking
				</li>
			</ul>
		</li>
	</ul>
	<hr>
	<p>Eventuali richieste possono essere inviate a: <a href="cifrischain@decifris.it">cifrischain&#64;decifris.it.</a></p>
	<p>
		Questo evento è stato pianificato dall'Acting Director e dal comitato organizzativo, che è rappresentato da:
		Dott. Massimo Bernaschi - <b>IAC-CNR</b>; <br>
		Prof. Marco Pedicini - <b>Università di Roma Tre</b>; <br>
		Dott. Giovanni Schmid - <b>ICAR-CNR</b>; <br>
		Prof. Daniele Venturi - <b>Università La Sapienza Roma</b>; <br>
		Prof. Vincenzo Vespri - <b>Università di Firenze</b>; <br>
		Prof. Andrea Visconti - <b>Università di Milano</b>; <br>
		Prof. Ivan Visconti - <b>Università di Salerno</b> - Coordinatore Cifris Chain.
	</p>
</div>